<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">组织添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <div style="padding: 0px 0px 20px 20px;">父级：{{parentZoneName}}</div>

                <el-form :model="list" :rules="rules" ref="addForm" label-width="80px">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="list.name"></el-input>
                                </el-form-item>
                            </el-col>

                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {newGuid} from "@/utils/guid";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props: ["listZoneDTO"],
        data() {
            return {

                loading: false,

                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    listZone:[],
                },
                list:{
                    zoneCode:'',
                    parentZoneCode:'00000000-0000-0000-0000-000000000000',
                    name:'',
                    sort:0,
                    listZone:[],
                },
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                    ],

                },

                parentZoneName:'',

            }
        },

        methods: {

            init(parentZoneCode){
                console.log(parentZoneCode)

                this.$refs.addForm.resetFields();
                this.addForm.listZone = [];
                this.list = {
                    zoneCode:'',
                    parentZoneCode:'00000000-0000-0000-0000-000000000000',
                    name:'',
                    sort:0,
                    listZone:[],
                }

                let aa  = JSON.stringify(this.listZoneDTO);
                aa =  aa.replace(/children/g,"listZone");
                this.addForm.listZone = JSON.parse(aa);

                if(parentZoneCode != ""){
                    this.list.parentZoneCode = parentZoneCode;
                    this.getMenuName(this.listZoneDTO,parentZoneCode);
                }else{
                    this.parentZoneName = "根级";
                }


            },

            closeSelf() {
                this.$emit("closeAdd");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if (valid) {

                        //console.log(this.addForm.listZone);
                        this.list.zoneCode = newGuid();
                        if(this.list.parentZoneCode ==="00000000-0000-0000-0000-000000000000"){
                            this.addForm.listZone.push(this.list);
                        }else {
                            this.addForm.listZone=this.add(this.addForm.listZone,this.list.parentZoneCode,1)
                        }

                        console.log(this.addForm.listZone);
                        this.addSubmit();

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            add(list,parentZoneCode,lable){
                for (let i in list) {
                    if (list[i].zoneCode === parentZoneCode) {
                        if(lable>4){
                            this.$emit("closeAdd");
                            this.$message({type: 'info', message: '只能添加五级'});
                        }else{
                            //console.log(lable);
                            //console.log(this.list);
                            //console.log(list[i]);
                            list[i].listZone.push(this.list);
                        }
                    }
                    if(list[i].listZone){
                        this.add(list[i].listZone,parentZoneCode,lable+1)
                    }
                }
                return list;
            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/Edit",
                    data: this.addForm
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                            this.$emit("menuShow");
                        } else {
                            this.$message({type: 'info', message: '添加失败'});
                        }

                    }
                )
            },


            getMenuName(listZoneDTO,zoneCode){
                for(let i=0;i<listZoneDTO.length;i++){
                    if(listZoneDTO[i].zoneCode == zoneCode){
                        this.parentZoneName = listZoneDTO[i].name;
                        return;
                    }

                    let listZoneDTOTemp = listZoneDTO[i].children;
                    if(listZoneDTOTemp != null){
                        this.getMenuName(listZoneDTOTemp,zoneCode);
                    }
                }

            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
